import type { ReactNode } from 'react';
import { SafeImage } from '@/components/common/safe-image';
import { AvatarWithStatus } from '../common/avatar-with-status';

type UserHeroProps = {
  headImg?: string;
  nickname?: string;
  sign?: string;
  addOn?: ReactNode;
};

export default function UserHero({ headImg, nickname = '', sign, addOn }: UserHeroProps) {
  return (
    <div className='relative bg-black/25 rounded w-full backdrop-blur'>
      <SafeImage
        className='absolute brightness-50 inset-0 size-full rounded bg-cover'
        fetchPriority='high'
        alt='user hero bg'
        src={headImg}
      />

      <div className='flex flex-col items-center justify-evenly gap-2 rounded p-2 backdrop-blur'>
        <AvatarWithStatus
          imageUrl={headImg}
          className='size-16 basis-16 mt-2 shadow flex-1'
          size={[64, 64]}
        />

        <div className='flex flex-col basis-16 mb-1 justify-center flex-1 items-center gap-2 text-white'>
          <h2 className='text-lg'>{nickname}</h2>

          {sign && <p className='text-sm break-all text-center'>{sign}</p>}
        </div>

        {addOn}
      </div>
    </div>
  );
}
